module.exports = __webpack_public_path__ + "static/media/mindy_thumbsup_physician.9f50c6c4.png";